import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './ComponentWithPopover.scss';

const CommonPopover = ({ title, message, className }) => (
    <Popover id="popover-basic" className={className}>
        <Popover.Header as="h3">{title}</Popover.Header>
        <Popover.Body>{message}</Popover.Body>
    </Popover>
);

const ComponentWithPopover = forwardRef((props, ref) => (
    <OverlayTrigger
        trigger="click"
        rootClose
        innerRef={ref}
        placement="bottom"
        overlay={CommonPopover(props)}
        popperConfig={props.popperConfig}
    >
        {props.children}
    </OverlayTrigger>
));

ComponentWithPopover.defaultProps = {
    children: {},
    popperConfig: {},
};

ComponentWithPopover.propTypes = {
    children: PropTypes.object,
    popperConfig: PropTypes.object,
};

CommonPopover.defaultProps = {
    title: '',
    message: '',
    className: '',
};

CommonPopover.propTypes = {
    title: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
};

export default ComponentWithPopover;
